/* eslint-disable no-loop-func */
//Author June Yee Leow
//Date Sep 1st, 2022
//This class serve as the component for PDF list
import {getReducer, getSetStateFunction, getAPICallGenerator, postAPICallGenerator, callBackGenerator, showMessage, hideMessage, getSession} from '../../../util/util';
import {Card, CardHeader, CardBody, Col, Row, Input, Button, Nav, NavItem, FormGroup, Label} from 'reactstrap';
import Compressor from 'compressorjs';
import {getCompressRatio} from '../util';
import DatePicker from 'react-datepicker';
import Dropzone from 'react-dropzone'
import { geocodeByAddress } from 'react-places-autocomplete';
import MyPlacesAutocomplete from '../../util/my-places-autocomplete';
import moment from 'moment';
import {NavLink, useParams} from 'react-router-dom';
import MySelect from '../../util/my-select';
import React, {useReducer, useEffect} from 'react';
import Signature from '../signature';

let session = getSession();

//initialize the state
const initialState = {
  name: session.userFirstName+' '+session.userLastName,
  states:[
    {key:'Northern Mariana Islands',value:'Northern Mariana Islands'},{key:'Alabama',value:'Alabama'},{key:'Alaska',value:'Alaska'},{key:'Arizona',value:'Arizona'},{key:'Arkansas',value:'Arkansas'},{key:'California',value:'California'},{key:'Colorado',value:'Colorado'},{key:'Connecticut',value:'Connecticut'},{key:'Delaware',value:'Delaware'},{key:'Florida',value:'Florida'},{key:'Georgia',value:'Georgia'},{key:'Hawaii',value:'Hawaii'},{key:'Idaho',value:'Idaho'},{key:'Illinois',value:'Illinois'},{key:'Indiana',value:'Indiana'},{key:'Iowa',value:'Iowa'},{key:'Kansas',value:'Kansas'},{key:'Kentucky',value:'Kentucky'},{key:'Louisiana',value:'Louisiana'},{key:'Maine',value:'Maine'},{key:'Maryland',value:'Maryland'},{key:'Massachusetts',value:'Massachusetts'},{key:'Michigan',value:'Michigan'},{key:'Minnesota',value:'Minnesota'},{key:'Mississippi',value:'Mississippi'},{key:'Missouri',value:'Missouri'},{key:'Montana',value:'Montana'},{key:'Nebraska',value:'Nebraska'},{key:'Nevada',value:'Nevada'},{key:'New Hampshire',value:'New Hampshire'},{key:'New Jersey',value:'New Jersey'},{key:'New Mexico',value:'New Mexico'},{key:'New York',value:'New York'},{key:'North Carolina',value:'North Carolina'},{key:'North Dakota',value:'North Dakota'},{key:'Ohio',value:'Ohio'},{key:'Oklahoma',value:'Oklahoma'},{key:'Oregon',value:'Oregon'},{key:'Pennsylvania',value:'Pennsylvania'},{key:'Rhode Island',value:'Rhode Island'},{key:'South Carolina',value:'South Carolina'},{key:'South Dakota',value:'South Dakota'},{key:'Tennessee',value:'Tennessee'},{key:'Texas',value:'Texas'},{key:'Utah',value:'Utah'},{key:'Vermont',value:'Vermont'},{key:'Virgin Islands',value:'Virgin Islands'},{key:'Virginia',value:'Virginia'},{key:'Washington',value:'Washington'},{key:'Washington DC',value:'Washington DC'},{key:'West Virginia',value:'West Virginia'},{key:'Wisconsin',value:'Wisconsin'},{key:'Wyoming',value:'Wyoming'}
  ],
  clients:[],
  originalClientFk:'',
  originalPropertyDataCollectorName:'',
  originalPropertyDataCollectorCompany:'',

  pdrFileIdentifier:'',
  additionalFileIdentifier:'',
  clientCaseNumber:'',

  propertyStreet:'',
  propertyCity:'',
  propertyCounty:'',
  propertyState:'',
  propertyZip:'',
  borrower:'',
  datetimeOriginalUPDEffective:'',
  propertyDataCollectorName:'',
  propertyDataCollectorCompany:'',
  propertyDataCollectorCompanyStreet:'',
  propertyDataCollectorCompanyCity:'',
  propertyDataCollectorCompanyCounty:'',
  propertyDataCollectorCompanyPropertyCounty:'',
  propertyDataCollectorCompanyState:'',
  propertyDataCollectorCompanyZip:'',
  propertyDataCollectorPhone:'',
  professionalLicenseType:'',
  professionalLicenseNumber:'',
  professionalLicenseState:'',
  professionalLicenseExpDate:'',
  dataCollectorAcknowledgement:'',
  propertyDataCollectorContactMethod:'',
  propertyDataCollectorContact:'',
  clientFk:'',
  hasUPD:undefined,
  showConfirmation:false,

  improvementFullfill:'',
  comment:'',
  signature:{},
  certified:false,
  datetimeVerification:'',
  photos:[],

  originalPdr:{}
};

//reducer function that perform state update
const reducer = getReducer();


const UPDPostCompletionReport  = (props)=>{
  const controller = new AbortController();

  let { updFk} = useParams();
  let newInitialState = Object.assign({}, initialState, {updFk:updFk});
  const [state, dispatch] = useReducer(reducer,newInitialState);

  //wrapper function
  const setState = getSetStateFunction(dispatch);

  const apiCallBack = callBackGenerator(setState);
  const httpGet = getAPICallGenerator(props, {signal:controller.signal});
  const httpPost = postAPICallGenerator(props, {signal:controller.signal});

  //run only once when component is loaded
  useEffect(()=>{
    getReport();
    getUPDeport();
    getAllClientProfiles();

    return ()=> controller.abort();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[]);

  //non API call but simpyl manage state
//function trigger for dropzone react.
  //this function contians two list of files, the accepted and rejected file per the configuration
  const onDrop = (acceptedFiles, rejectedFiles, type='Misc', typeFk=0, description='')=>{
    let existingFiles = [];
    if(acceptedFiles.length>0){
      for(let i=0;i<acceptedFiles.length;i++){
        existingFiles.push(acceptedFiles[i]);
        let name = existingFiles[i].name;
        let token = name.split('.');
        let extension = '';

        if(token.length>0){
          extension = token[token.length-1];
          extension = extension.toLowerCase();
        }

        if(extension!=='png'&&extension!=='jpg'&&extension!=='jpeg'){
          showMessage('error','Please upload only PNG/JPG image.');
        }
        else{
          let compressRatio = getCompressRatio(acceptedFiles[i].size);
          new Compressor(acceptedFiles[i], {
            quality: compressRatio, // 0.6 can also be used, but its not recommended to go below.
            success: (compressedResult) => {
              // compressedResult has the compressed file.
              // Use the compressed file to upload the images to your server.        
              let compressedFile = new File([compressedResult], acceptedFiles[i].name);

              const reader = new FileReader();
              reader.onload = () => {
                const fileAsBinaryString = reader.result;
                let base64 = btoa(fileAsBinaryString);
                let photos = state.photos.slice();
  
                photos.push({name:acceptedFiles[i].name, base64:base64, status:'Pending', size:compressedFile.size, type:type, typeFk:typeFk, description:description});
                setState({photos:photos});
              }
              reader.readAsBinaryString(compressedFile);
            },
          });
        }
      }
    }
  }

  const googlePlaceOnChange = (address)=>{
    if(address!==state.propertyStreet){

      if(address.indexOf(',')!==-1 && address.length>10){
        geocodeByAddress(address)
          .then(
            results => {
              //always use the first returned result
              let targetResult = results[0];

              let addressComponents = targetResult.address_components;

              let streetNumber = '';
              let route = '';
              let city = '';
              let county = '';
              let state = '';
              let zip = '';

              //go through the address components and grab the street, city, county, state, and zip
              for(let i=0;i<addressComponents.length;i++){
                if(addressComponents[i].types[0]==='street_number')
                  streetNumber = addressComponents[i].long_name;
                else if(addressComponents[i].types[0]==='route')
                  route = addressComponents[i].long_name;
                else if(addressComponents[i].types[0]==='locality'&&addressComponents[i].types[1]==='political')
                  city = addressComponents[i].long_name;
                else if(addressComponents[i].types[0]==='administrative_area_level_2'&&addressComponents[i].types[1]==='political')
                  county = addressComponents[i].long_name;
                else if(addressComponents[i].types[0]==='administrative_area_level_1'&&addressComponents[i].types[1]==='political')
                  state = addressComponents[i].long_name;
                else if(addressComponents[i].types[0]==='postal_code')
                  zip = addressComponents[i].long_name;
              }

              let street = '';
              let stateToUpdate = {};

              if(streetNumber!==''&&route!=='')
                street = streetNumber+' '+route;

              if(street!=='')
                stateToUpdate.propertyStreet=street;
              if(city!=='')
                stateToUpdate.propertyCity=city;
              if(county!=='')
                stateToUpdate.propertyCounty=county;
              if(state!=='')
                stateToUpdate.propertyState=state;
              if(zip!=='')
                stateToUpdate.propertyZip=zip;
              setState(stateToUpdate);
            })
          .catch(
            error => {
              console.log(error);
            }
          );
      }
      else{
        setState({propertyStreet:address});
      }
    }
  }

  const googlePlaceOnChange2 = (address)=>{
    if(address!==state.propertyDataCollectorCompanyStreet){

      if(address.indexOf(',')!==-1 && address.length>10){
        geocodeByAddress(address)
          .then(
            results => {
              //always use the first returned result
              let targetResult = results[0];

              let addressComponents = targetResult.address_components;

              let streetNumber = '';
              let route = '';
              let city = '';
              let county = '';
              let state = '';
              let zip = '';

              //go through the address components and grab the street, city, county, state, and zip
              for(let i=0;i<addressComponents.length;i++){
                if(addressComponents[i].types[0]==='street_number')
                  streetNumber = addressComponents[i].long_name;
                else if(addressComponents[i].types[0]==='route')
                  route = addressComponents[i].long_name;
                else if(addressComponents[i].types[0]==='locality'&&addressComponents[i].types[1]==='political')
                  city = addressComponents[i].long_name;
                else if(addressComponents[i].types[0]==='administrative_area_level_2'&&addressComponents[i].types[1]==='political')
                  county = addressComponents[i].long_name;
                else if(addressComponents[i].types[0]==='administrative_area_level_1'&&addressComponents[i].types[1]==='political')
                  state = addressComponents[i].long_name;
                else if(addressComponents[i].types[0]==='postal_code')
                  zip = addressComponents[i].long_name;
              }

              let street = '';
              let stateToUpdate = {};

              if(streetNumber!==''&&route!=='')
                street = streetNumber+' '+route;

              if(street!=='')
                stateToUpdate.propertyDataCollectorCompanyPropertyStreet=street;
              if(city!=='')
                stateToUpdate.propertyDataCollectorCompanyPropertyCity=city;
              if(county!=='')
                stateToUpdate.propertyDataCollectorCompanyPropertyCounty=county;
              if(state!=='')
                stateToUpdate.propertyDataCollectorCompanyPropertyState=state;
              if(zip!=='')
                stateToUpdate.propertyDataCollectorCompanyPropertyZip=zip;
              setState(stateToUpdate);
            })
          .catch(
            error => {
              console.log(error);
            }
          );
      }
      else{
        setState({propertyDataCollectorCompanyPropertyStreet:address});
      }
    }
  }


  const removeFile = (field,index)=>{
    let photos = state.photos.slice();
    photos.splice(index, 1);
    setState({photos:photos});
  }

  
  const uploadPhotos = async ()=>{
    let photos = state.photos.slice();

    let callCounter= 0;
    for(let i=0;i<photos.length;i++){
      if(!photos[i].ID || photos[i].ID===-1){

        let updateCallBack = (ID)=>{
          callCounter++;
          photos[i].ID = ID;
          if(callCounter>=photos.length){
            setState({photos:photos});
          }
        }

        await uploadPhoto(photos[i], updateCallBack);
      }
    }
  }

  //API call
  const submitUUPDeport = async (e)=>{
    e.preventDefault();
    let fail = false;
    if((!state.signature.draw || state.signature.draw==='' )&& (!state.signature.upload || state.signature.upload==='')){
      showMessage('error', 'Please sign the report or upload your signature with a photo.');
      fail = true;
    }

    if(!fail){
      let updateCallBack = async ()=>{
        await uploadPhotos();
        sendUUPDequest();
      }

      uploadSignature(updateCallBack);
    }
  }

  const getAllClientProfiles = () => {
    let callBack = (response)=>{
      let code = response.data.code;

      if(code==='00'){

        let clients = [];
        for(let i=0;i<response.data.data.length;i++){
          let client = response.data.data[i];

          let tmp = {};
          tmp.key = client.ID;
          tmp.value = client.company;

          clients.push(tmp);
        }

        setState({clients:clients});
      }
    };
    httpGet('client/get/limit=-1&offset=-1', '', 'Oops, something went wrong and could not retrieve client profiles.', callBack);
  }

  const uploadPhoto = async (photo, updateCallBack) => {
    let messageID = showMessage('non-dismissable','Uploading '+photo.name+', please do not close your browser.');

    let parameters = [
      {
        field:'updFk',
        value:state.updFk
      },
      {
        field:'typeFk',
        value:photo.typeFk
      },
      {
        field:'type',
        value:photo.type
      },
      {
        field:'description',
        value:photo.description
      },
      {
        field:'name',
        value:photo.name
      },
      {
        field:'size',
        value:photo.size
      },
      {
        field:'uploadedFile',
        value:photo.base64
      },
      {
        field:'uploaderName',
        value:state.name
      }
    ];

    let callBack = (response)=>{
      let code= response.data.code;

      hideMessage(messageID);
      if(code!=='00'){

      }
      else{
        let data = response.data.data;
        updateCallBack(data.ID);
      }
    };

    let errorCallBack = (error)=>{

      hideMessage(messageID);
    };

    await httpPost('uniformPropertyDataset/photo/upload', parameters, '', 'Oops, something went wrong on uploading photo and could not save the report. Please try again later.', callBack, errorCallBack);
  }

  const sendUUPDequest = () => {
    let parameters = [
      {
        field:'updFk',
        value:state.updFk
      },
      {
        field:'improvementFullfill',
        value:state.improvementFullfill
      },
      {
        field:'dataCollectorAcknowledgement',
        value:state.improvementFullfill
      },
      {
        field:'dataCollectorContact',
        value:state.propertyDataCollectorContact
      },
      {
        field:'dataCollectorContactMethod',
        value:state.propertyDataCollectorContactMethod
      },
      {
        field:'comment',
        value:state.comment
      },
      {
        field:'datetimeOriginalUPDEffective',
        value:state.datetimeOriginalUPDEffective
      },
      {
        field:'propertyDataCollectorName',
        value:state.propertyDataCollectorName
      },
      {
        field:'propertyDataCollectorCompany',
        value:state.propertyDataCollectorCompany
      }
    ];
    console.log(parameters)
   
    let callBack = apiCallBack([{state:'hasUPD', value:true},{state:'showConfirmation', value:true}]);
    httpPost('uniformPropertyDataset/pcr/create', parameters, 'PCR Request submitted successfully.', 'Oops, something went wrong and could not submit this PCR request. Please try again later.', callBack);
  }

  const updateFileDescription=(index, field, description)=>{
    let photos = state.photos.slice();
    photos[index][field] = description;
    setState({photos:photos});
  }

  const uploadSignature = (updateCallBack) => {
    let base64;
    let signature = Object.assign({}, state.signature);
    if(signature.draw && signature.draw!=='')
      base64 = signature.draw;
    else
      base64 = signature.upload;

    let photo = {
      type:'PCR Signature',
      typeFk:0,
      base64:base64,
      name:'signature',
      description:'PCR Signature',
      uploaderName:state.name
    };

    let parameters = [
      {
        field:'updFk',
        value:state.updFk
      },
      {
        field:'typeFk',
        value:photo.typeFk
      },
      {
        field:'type',
        value:photo.type
      },
      {
        field:'description',
        value:photo.description
      },
      {
        field:'name',
        value:photo.name
      },
      {
        field:'size',
        value:photo.size
      },
      {
        field:'uploadedFile',
        value:photo.base64
      },
      {
        field:'uploaderName',
        value:state.name
      }
    ];
    
    let messageID = showMessage('non-dismissable','Uploading your signature please do not close your browser.');

    let callBack = (response)=>{
      let code= response.data.code;

      hideMessage(messageID);
      if(code!=='00'){

      }
      else{
        let data = response.data.data;
        updateCallBack(data.ID);
      }
    };

    let errorCallBack = (error)=>{

      hideMessage(messageID);
    };
   
    httpPost('uniformPropertyDataset/photo/upload', parameters, '', 'Oops, something went wrong on uploading photo and could not save the report. Please try again later.', callBack, errorCallBack);
  }

  const getReport = () => {
    let callBack = apiCallBack([{state:'originalPdr', key:'data'},{state:'clientFk', key:'data.clientFk'}]);
    httpGet('uniformPropertyDataset/'+state.updFk, '', 'Oops, something went wrong and could not load this report. Please try again later.', callBack);
  }

  const getUPDeport = () => {
    let callBack = (response)=>{
      let code = response.data.code;
      if(code==='00'){
        setState({hasUPD:response.data.data.length>0});
      }
    };
    httpGet('uniformPropertyDataset/pcr/'+state.updFk, '', 'Oops, something went wrong and could not load PCR report for this UPD. Please try again later.', callBack);
  }

  //render
  let professionalLicenseExpDate;
  if(state.professionalLicenseExpDate!==''&&state.professionalLicenseExpDate!=='0000-00-00')
    professionalLicenseExpDate = moment(state.professionalLicenseExpDate).toDate();

  let datetimeOriginalUPDEffective;
  if(state.datetimeOriginalUPDEffective!==''&&state.datetimeOriginalUPDEffective!=='0000-00-00')
    datetimeOriginalUPDEffective = moment(state.datetimeOriginalUPDEffective).toDate();

  let datetimeVerification;
  if(state.datetimeVerification!==''&&state.datetimeVerification!=='0000-00-00')
    datetimeVerification = moment(state.datetimeVerification).toDate();

  let content;

  if(state.showConfirmation){
    content = <div style={{background:"#fff"}}>
      <br/><br/>
      <center>
        Your PCR request had been submitted successfully. An email will be send to you once it is ready to be download.
      </center>
      <br/>
    </div>
  }
  else if(state.hasUPD===false){
    content = <form onSubmit={submitUUPDeport}>
      <Card>
        <CardHeader className="header-color">
          PCR Report
        </CardHeader>
        <CardBody>
          <Card>
            <CardHeader><i className="fa fa-edit"/> This PCR</CardHeader>
            <CardBody>
              <label><font color="red">*</font>Have the improvements been completed in accordance with the requirements and conditions stated in the original property data report?</label>
              <MySelect
                type="select"
                required={true}
                value={state.improvementFullfill}
                onChange={(v)=>setState({improvementFullfill:v})}
                options={[{label:"Yes",value:"True"},{label:"No",value:"False"}]}
              />
              <label><font color="red">*</font>Data collector to indicate their acknowledgement and adherence to the Certifications and Limiting Conditions. </label>
              <MySelect
                type="select"
                required={true}
                value={state.dataCollectorAcknowledgement}
                onChange={(v)=>setState({dataCollectorAcknowledgement:v})}
                options={[{label:"Yes",value:"True"},{label:"No",value:"False"}]}
              />
              <br/>
              <label>{state.improvementFullfill==='False'?<font color="red">*</font>:null}Comment</label>
              <Input required={state.improvementFullfill==='False'} type="textarea" rows="3" value={state.comment} onChange={(e)=>{setState({comment:e.target.value})}}/>

              <br/>
              <label>Photos</label>
              <br/>
              <Dropzone hidden={props.disabled} onDrop={(accepted, rejected)=>{onDrop(accepted, rejected, 'Post Completion', 0)}} className="my-dropzone">
              {
                ({getRootProps, getInputProps}) => (
                  <div
                    {...getRootProps({
                      className: 'my-dropzone',
                    })}
                  >
                    <input {...getInputProps()} />
                    <center>Choose files to upload</center>
                  </div>
                )
              }
              </Dropzone>
              {
                state.photos.map(
                  (photo, index)=>{
                    return <div key={index} className="display-inline" style={{width:200, height:250, margin:5}}>
                      <div>
                        <i className="fa fa-times red-color cursor-pointer" onClick={(e)=>removeFile('photos',index)}/> {photo.name.length>16?photo.name.substr(0,16)+'...':photo.name}
                      </div>
                      <img alt="pic" width="200" height="200" src={photo.status==='Pending'?"data:image/png;base64, "+photo.base64:photo.presign_url}/>
                      {!photo.ID?<div><Input type="text" placeholder="Description of photo" value={photo.description} onChange={(e)=>updateFileDescription(index, 'description', e.target.value)}/>
                      <div style={{marginTop:'5px'}}/></div>:<i>{photo.description}</i>}
                    </div>
                  }
                )
              }
            </CardBody>
          </Card>

          <br/><br/>
          <Card>
            <CardHeader><i className="fa fa-user"/> Property Data Collector Information</CardHeader>
            <CardBody>
              <Row>
                <Col sm="4">
                  <label><font color="red">*</font>Name</label>
                  <Input required={true} type="text" value={state.propertyDataCollectorName} onChange={(e)=>setState({propertyDataCollectorName:e.target.value})}/>
                </Col>
                <Col sm="4">
                  <label><font color="red">*</font>Contact Method</label>
                  <Input required={true} type="select" value={state.propertyDataCollectorContactMethod} onChange={(e)=>setState({propertyDataCollectorContactMethod:e.target.value})}>
                    <option value=""></option>
                    <option value="Phone">Phone</option>
                    <option value="Email">Email</option>
                  </Input>
                </Col>
                <Col sm="4">
                  <label><font color="red">*</font>Contact</label>
                  <Input required={true} type="text" value={state.propertyDataCollectorContact} onChange={(e)=>setState({propertyDataCollectorContact:e.target.value})}/>
                </Col>
              </Row>
              <Row style={{marginTop:'15px'}}>
                <Col sm="12">
                  <label><font color="red">*</font>Company Name</label>
                  <Input required={true} type="text" value={state.propertyDataCollectorCompany} onChange={(e)=>setState({propertyDataCollectorCompany:e.target.value})}/>
                </Col>
              </Row>
              <br/>
              <label><font color="red">*</font>Signature</label><br/>
              <Signature update={(type, base64)=>setState({signature:Object.assign({}, state.signature, {[type]:base64})})}/>
              <br/>
              <div className="display-inline" style={{verticalAlign:'top'}}>
                <FormGroup check>
                  <Label check>
                    <Input required={true} type="checkbox" value={state.certified} onChange={(e)=>setState({certified:!state.certified})}/>
                  </Label>
                </FormGroup>
              </div>
              <div className="display-inline" style={{verticalAlign:'top', fontSize:'12px'}}>
                I have performed a visual observation of the subject property to determine if the physical deficiencies observed in the original property data report have been repaired.
              </div>
              <br/><br/>
              <div style={{fontSize:'12px'}}>
                If this report was transmitted as an "electronic record" containing my "electronic signature," as those terms are defined in applicable federal and/or state laws (excluding audio and video recordings), or as a facsimile transmission of this report containing a copy or representation of my signature, shall be as effective, enforceable and valid as if a paper version of this report were delivered containing my original handwritten signature.
              </div>
            </CardBody>
          </Card>

          <br/><br/>
          <div className="align-right">
            <Button color="warning">Submit & Generate PCR Report</Button>
          </div>
        </CardBody>
      </Card>
    </form>;
  }
  else if(state.hasUPD===true){
    content = <div style={{background:"#fff"}}>
      <br/><br/>
      <center>
        A PCR report is already submitted. Please wait for it to be generated before creating another request.
      </center>
      <br/>
    </div>
  }
  return <div>
    <div>
      <Row>
        <Col sm="6">
          
        </Col>
        <Col sm="6" className="align-right">
        </Col>
      </Row>
    </div>
    <Nav tabs>
      <NavItem>
        <NavLink className="nav-link" to={"/uniform-property-dataset/"+state.updFk}>UPD (Uniform Property Dataset Report)</NavLink>
      </NavItem>
      <NavItem>
        <NavLink className="nav-link active" to="#">PCR (Post Completion Report)</NavLink>
      </NavItem>
      <NavItem>
        <NavLink className="nav-link" to={"/uniform-property-dataset/file/"+state.updFk}>Generated Report</NavLink>
      </NavItem>
      <NavItem>
        <a className="nav-link" href="https://www.smartdraw.com/" target="_blank" rel="noopener noreferrer">Floor Plan - Smart Draw</a>
      </NavItem>
      <NavItem>
        <a className="nav-link" href="https://www.cubi.casa/" target="_blank" rel="noopener noreferrer">Floor Plan - Cubi Casa</a>
      </NavItem>
    </Nav>
    <br/>

    {content}
  </div>
}


export default UPDPostCompletionReport;